/* ==========================================================================
   GC store carousel — photo slider on the individual store pages.
   Progressive enhancement: the markup is a plain scroll container, so it
   still works (and still scrolls) if this never runs.
   ========================================================================== */
(function () {
  'use strict';
  if (window.gcCarouselReady) return;
  window.gcCarouselReady = true;

  function setup(root) {
    var track = root.querySelector('.gc-carousel__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.gc-carousel__slide'));
    var prev = root.querySelector('.gc-carousel__nav--prev');
    var next = root.querySelector('.gc-carousel__nav--next');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.gc-carousel__dot'));
    if (!track || slides.length < 2) return;

    var index = 0;

    function render() {
      dots.forEach(function (d, i) {
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      slides.forEach(function (s, i) {
        // Keep off-screen slides out of the tab order and the a11y tree.
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      root.setAttribute('data-index', String(index));
    }

    function goTo(i, smooth) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      render();
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });

    // Keep state in sync when the user swipes/scrolls the track directly.
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var nearest = 0, best = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; nearest = i; }
        });
        if (nearest !== index) { index = nearest; render(); }
      }, 90);
    }, { passive: true });

    render();
  }

  function init() {
    document.querySelectorAll('.gc-carousel').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
